import { HealthCheck } from './components/HealthCheck'
import './App.css'

function App() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-brand-primary mb-2">
            Kombu
          </h1>
          <p className="text-content-secondary">
            Plataforma de memorias gastronómicas
          </p>
        </div>

        <div className="space-y-6">
          <HealthCheck />

          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-2xl font-semibold text-content-primary mb-4">
              Bienvenido al proyecto Kombu
            </h2>
            <p className="text-content-secondary">
              La conexión entre frontend y backend está funcionando correctamente.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
